import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatSidenavModule } from '@angular/material/sidenav';

@NgModule({
    exports: [MatIconModule, MatSidenavModule, MatListModule, MatRadioModule, MatMenuModule, MatButtonModule],
})
export class SettingsMaterialModule {}
